import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { IBillingReportItem, IBillingReportRequest, IPagedBillingReportResult } from './billing-report/ibilling-report';
import { IPatientReport, IReportRequest, IPagedPatientReportResult } from './ireports';
import { BaseRespone, PaginationResult } from 'src/app/models/common.response';
import { BehaviorSubject, catchError, Observable, tap } from 'rxjs';
import { environment } from "src/environments/environment";
import { LoginService } from 'src/app/login.service';

@Injectable({
  providedIn: 'root'
})
export class ReportsService {

  private _opd: BehaviorSubject<IPatientReport[] | null> = new BehaviorSubject<IPatientReport[] | null>(null);
  private _ipd: BehaviorSubject<IPatientReport[] | null> = new BehaviorSubject<IPatientReport[] | null>(null);
  private _billing: BehaviorSubject<IBillingReportItem[] | null> = new BehaviorSubject<IBillingReportItem[] | null>(null);
  private _pagination: BehaviorSubject<PaginationResult | null> = new BehaviorSubject<PaginationResult | null>(null);

  constructor(private _httpClient: HttpClient, private _loginService: LoginService) { }

  get opd$(): Observable<IPatientReport[] | null> {
    return this._opd.asObservable();
  }

  get ipd$(): Observable<IPatientReport[] | null> {
    return this._ipd.asObservable();
  }

  get billing$(): Observable<IBillingReportItem[] | null> {
    return this._billing.asObservable();
  }

  get pagination$(): Observable<PaginationResult | null> {
    return this._pagination.asObservable();
  }

  getPatientOpdReport(request?: IReportRequest): Observable<BaseRespone<IPagedPatientReportResult>> {
    return this._httpClient.post<BaseRespone<IPagedPatientReportResult>>(`${environment.baseURl}/Report/opd`, request ?? {}).pipe(
      tap((response) => {
        if (response.isSuccess && response.result) {
          this._opd.next(response.result.patientReportDetails);
        }
      }),
      catchError((error) => {
        console.error('Error to fetching data:', error);
        throw error;
      })
    );
  }

  getPatientIpdReport(request?: IReportRequest): Observable<BaseRespone<IPagedPatientReportResult>> {
    return this._httpClient.post<BaseRespone<IPagedPatientReportResult>>(`${environment.baseURl}/Report/ipd`, request ?? {}).pipe(
      tap((response) => {
        if (response.isSuccess && response.result) {
          this._ipd.next(response.result.patientReportDetails);
        }
      }),
      catchError((error) => {
        console.error('Error to fetching data:', error);
        throw error;
      })
    );
  }

  getBillingReport(request: IBillingReportRequest): Observable<BaseRespone<IPagedBillingReportResult>> {
    return this._httpClient.post<BaseRespone<IPagedBillingReportResult>>(
      `${environment.baseURl}/Report/billing`, request
    ).pipe(
      tap((response) => {
        if (response.isSuccess && response.result) {
          this._billing.next(response.result.billingReportDetails);
        }
      }),
      catchError((error) => {
        console.error('Error to fetching data:', error);
        throw error;
      })
    );
  }

   get isAdminRes(): boolean {
    const userRoles = this._loginService.getUserRoleFromToken() || [];
    return userRoles.includes('Admin') || userRoles.includes('Receptionist');
  }

}

